/** @format */

import {CellContext} from '@tanstack/react-table';

import {divideBySpaces} from 'helpers/numberHelpers';
import {toStr} from 'helpers/stringHelpers';
import {TanStackTableData, TanStackTableValue} from 'components/Table/core/types';

import {Text} from './styles';

const FormattedCell = (info: CellContext<TanStackTableData, TanStackTableValue>) => {
  const value = info.getValue();

  if (typeof value === 'number') {
    return <Text>{divideBySpaces(value)}</Text>;
  }
  return <Text>{toStr(value)}</Text>;
};

export {FormattedCell};
